export default __webpack_public_path__ + "static/media/get-a-pic-btn-frame.06b589a1.png";